import React, { useState, useEffect } from 'react'
import { Row, Form, Button, Col } from 'react-bootstrap';
import {  useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { toast } from 'react-toastify';
import { useGetallqandaQuery } from '../../slices/teachers/teacherQuestionsApiSlice';
import { useGetPublicsubjectQuery } from '../../slices/teachers/subjectApiSlice';
import TeacherHeader from '../../components/TeacherHeader';
import TeacherNavbar from '../../components/TeacherNavbar';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import NoQuestions from '../../components/NoQuestions';
import TeacherOldQuestion2 from '../../components/TeacherOldQuestion2';
import PaginateReuseAnswers from '../../components/PaginateReuseAnswers';

const TeacherReuseAnswer = () => {

    const navigate = useNavigate();

    const { id, sid, pageNumber } = useParams();
    const { teacherInfo } = useSelector((state) => state.authTeacher);

    const [subjecttittle, setSubjecttittle] = useState('');
    const [teachername, setTeachername] = useState('');

    const { data } = useGetPublicsubjectQuery(id);
    const { data: allQandA, isLoading, error  } = useGetallqandaQuery({id, pageNumber});

    useEffect(() => {
        setSubjecttittle(data?.tittle)
    }, [data])

    useEffect(() => {
        if(!teacherInfo) {
            navigate('/teacherlogin')
        }
        if(teacherInfo) {
            setTeachername(teacherInfo.firstname + ' ' + teacherInfo.lastname);
        }
    }, [navigate, teacherInfo])

  return (
    <div>
        <TeacherNavbar />
        <div className="main-content" id="panel">
            <TeacherHeader /><br /><br /><br /><br />        
            <div className="container-fluid mt--6">
                {isLoading ? ( 
                    <Loader />
                ) : error ? (
                    <Message variant='danger'>
                        {error?.data?.message || error.error}
                    </Message>
                ) : (
                    <div className="row">
                        <div className="col-xl-12 questionTitle">   
                            <h4>  <span className='tittleColor4 ' style={{textTransform: 'capitalize'}}>
                                {subjecttittle}
                            </span></h4>
                        </div>
                        {allQandA?.newArr3?.map((question, index) => (
                            <div className="col-md-6 col-xl-4" key={index}>   
                                <div className="card timeb2">                
                                    <div className="card-body ">
                                        <div className="timeline timeline-one-side " data-timeline-content="axis" data-timeline-axis-style="dashed">                       
                                        <br /> <TeacherOldQuestion2 question={question} teachername={teachername} sid={sid} className="" />     <br />              
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                        {allQandA?.newArr3?.length === 0 && (
                            <div  className="col-md-6 col-xl-4 ">  
                                <NoQuestions />
                            </div>
                        )}
                        <PaginateReuseAnswers
                            pages={allQandA?.pages}
                            page={allQandA?.page}
                            link='teacherreuseanswer'
                            id={id}
                            sid={sid}
                            /><br /><br />
                    </div>
                )} 
            </div>
        </div>
    </div>
  )
}

export default TeacherReuseAnswer
